module.exports = __webpack_public_path__ + "fonts/SpareBank1-It-Web.e4e4cd6.woff2";